import React from "react";
import { Spinner } from "react-bootstrap";
import "../App.css";

export interface IProps {
  /**
   * 背景を透過させない場合はfalse
   */
  transparent?: boolean;
}

class Loading extends React.Component<IProps> {
  render(): JSX.Element {
    const { transparent } = this.props;
    const overlayClass =
      transparent || typeof transparent === "undefined"
        ? "loading-overlay-transparent"
        : "loading-overlay";
    return (
      <div className={overlayClass}>
        <Spinner animation="border" variant="primary" className="loading" />
      </div>
    );
  }
}

/**
 * Loading
 */
export default Loading;
